import { StepState } from "../../types/types";
import { useStepperContext } from "../Stepper/Stepper";
import "./_step.scss";

interface StepComponentProps {
  label?: string;
  description?: React.ReactNode;
  isCompletedStep?: boolean;
  state?: StepState;
  children?: React.ReactNode;
  index?: number;
  isCurrentStep?: boolean;
  isLastStep?: boolean;
}

export const Step: React.FC<StepComponentProps> = props => {
  const { label, description, isCompletedStep, children, index, isCurrentStep, isLastStep } = props;

  const { clickable, onClickStep } = useStepperContext();

  const indicatorStyle: React.CSSProperties = {
    backgroundColor: isCompletedStep ? "green" : isCurrentStep ? "blue" : "gray"
  };

  const trackStyle: React.CSSProperties = {
    position: "absolute",
    backgroundColor: "lightgray",
    height: "2px",
    width: "100%",
    top: "12px",
    left: "50%",
    display: isLastStep ? "none" : "block"
  };

  const handleClick = () => {
    if (clickable && onClickStep && typeof index === "number") {
      onClickStep(index);
    }
  };

  return (
    <div className="step d-flex flex-column align-items-center" onClick={handleClick}>
      <div
        className="step__indicator mb-4 mr-0 d-flex justify-content-center align-items-center"
        style={indicatorStyle}
      >
        {isCompletedStep ? "✓" : index !== undefined ? index + 1 : ""}
      </div>

      {!isLastStep && <div className="step-track" style={trackStyle} />}

      <div className="step-content">
        {label && <div className="step-label">{label}</div>}
        {description && <div className="step-description">{description}</div>}
      </div>

      {isCurrentStep && children && <div className="step-children">{children}</div>}
    </div>
  );
};
